import clsx from "clsx";
import { CSSProperties, FC, ReactElement } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  coursesCalendarSlotIdsByHourSF,
  selectedCoursesCalendarSlotIdsAtom,
  SelectionEnum,
  setCheckedHandlerCoursesCalendarSlots,
  wholeRowSelectedCoursesCalendarSF,
} from "@ryde/shared";

import { CALENDAR_HOUR_LABEL_PAD_LENGTH } from "./courses-calendar.constants";

interface IHour {
  style: CSSProperties;
  /** Calendar hour row 0–24 (same as grid selection keys). */
  hourIndex: number;
}

export const CoursesCalendarHourLabelCell: FC<IHour> = ({
  style,
  hourIndex: hour,
}): ReactElement => {
  const label =
    hour === 24
      ? "24:00"
      : `${String(hour).padStart(CALENDAR_HOUR_LABEL_PAD_LENGTH, "0")}:00`;
  const setSelectedSlotIds = useSetRecoilState(
    selectedCoursesCalendarSlotIdsAtom,
  );
  const rowSlotIds = useRecoilValue(coursesCalendarSlotIdsByHourSF(hour));
  const rowSelectedState = useRecoilValue(
    wholeRowSelectedCoursesCalendarSF(hour),
  );

  const setChecked = (value: SelectionEnum): void => {
    setCheckedHandlerCoursesCalendarSlots[value]({
      setter: setSelectedSlotIds,
      slotIds: rowSlotIds,
    });
  };

  return (
    <div
      className={clsx("cell_pass_fixed", {
        "cc-hour-row--tint": rowSelectedState !== SelectionEnum.None,
      })}
      style={style}
    >
      <span className="checkbox">
        <SelectOptionsDropdown
          checked={rowSelectedState}
          setChecked={setChecked}
        />
      </span>
      <span className="cc-hour-label-text">{label}</span>
    </div>
  );
};
